const REQUEST_TIMEOUT_MS = 120000;
const pendingRequests = new Map();

let responseHandlerInstalled = false;

function installResponseHandler() {
  if (responseHandlerInstalled || typeof window === 'undefined') return;

  // The native WKWebView should call:
  // window.onIOSIAPResponse({ requestId, success, ...result })
  window.onIOSIAPResponse = (result = {}) => {
    const pending = pendingRequests.get(result.requestId);
    if (!pending) return;

    clearTimeout(pending.timeoutId);
    pendingRequests.delete(result.requestId);

    if (result.success === false || result.error) {
      pending.reject(new Error(result.error || 'The App Store request failed.'));
      return;
    }
    pending.resolve(result);
  };
  responseHandlerInstalled = true;
}

function getNativeHandler() {
  if (typeof window === 'undefined') return null;
  return window.webkit?.messageHandlers?.iosIap
    || window.webkit?.messageHandlers?.iap
    || null;
}

export function isIOSIAPAvailable() {
  return Boolean(getNativeHandler());
}

export function sendIOSIAPRequest(action, payload = {}) {
  installResponseHandler();
  const handler = getNativeHandler();

  if (!handler) {
    return Promise.reject(new Error('App Store purchases are unavailable outside the iOS app.'));
  }

  const requestId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      pendingRequests.delete(requestId);
      reject(new Error('The App Store request timed out. Please try again.'));
    }, REQUEST_TIMEOUT_MS);

    pendingRequests.set(requestId, { resolve, reject, timeoutId });

    try {
      handler.postMessage({ action, requestId, ...payload });
    } catch (error) {
      clearTimeout(timeoutId);
      pendingRequests.delete(requestId);
      reject(error);
    }
  });
}

export const loadIOSProducts = (productIds) => (
  sendIOSIAPRequest('loadProducts', { productIds })
);

export const purchaseIOSProduct = ({ productId, planId, userToken }) => (
  sendIOSIAPRequest('purchase', { productId, planId, userToken })
);

export const restoreIOSPurchases = (userToken) => (
  sendIOSIAPRequest('restore', { userToken })
);
